<breadcrumb
  [paginas]="[
    { route: '/home', name: 'Home' },
    {
      route: '/painel-atividade-psicologo',
      name: 'Painel de Atividade do Psicólogo '
    },
    {
      route: '/painel-atividade-psicologo/aprovacao-atividades',
      name: 'Aprovação Atividades '
    }
  ]"
/>

<!-- TITULO -->
<section class="section-saudacao">
  <div class="container">
    <h2 class="titulo-page">Aprovação Atividades</h2>

    <app-btn-back class="btn_voltar_consulta"></app-btn-back>
  </div>
</section>

<section class="section-informacoes-psicologo">
  <div class="container">
    <p>
      <b>Atividades Referente</b>
    </p>
    <p class="icon-paragraph">
      <i class="fa-solid fa-user" aria-hidden="true"></i>Psicólogo(a):
      {{ jornada?.nomePsicologo }} - {{ jornada?.cpfPsicologo }}
    </p>
    <p class="icon-paragraph">
      <img
        src="../../../assets/img/icons/icon-nome-escola.svg"
        title="Diretoria de Ensino"
        alt=""
      />
      <b>URE: </b> {{ jornada?.nomeDiretoria }}
    </p>
    <p class="icon-paragraph">
      <img
        src="../../../assets/img/icons/icon-nome-escola.svg"
        title="Diretoria de Ensino"
        alt=""
      />
      <b>Escola: </b> {{ jornada?.nomeEscola }}
    </p>
    <p class="horas-trabalhadas">
      Total de horas trabalhadas:<b>{{
        totalHorasTrabalhadas | date : "HH:mm"
      }}</b>
    </p>
  </div>
</section>

<section class="section-grid-consulta-ponto" [class.aprovacao-carregando]="carregando">
  <div class="container">
    <div class="row_registros">
      <h3>Listagem de Atividades realizadas</h3>
    </div>

    @if (carregando) {
      <div class="overlay-carregando" role="status" aria-live="polite">
        <div class="overlay-carregando__conteudo">
          <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
          <p>{{ mensagemCarregando }}</p>
        </div>
      </div>
    }

    <div class="conteudo-atividades" [class.conteudo-atividades--bloqueado]="carregando">
      @if (!atividadesExibidas.length) {
        <p class="alert">
          Nenhuma atividade cadastrada para esta jornada (código {{ jornadaId }}).
          Volte ao <b>Painel de Atividade do Psicólogo</b> e abra a aprovação pelo ícone de check
          na linha da jornada que possui atividades enviadas para avaliação.
        </p>
      }
      @if (atividadesExibidas.length && !atividadesEnviadasParaAprovacao.length) {
        <p class="alert">Nenhuma atividade foi enviada para aprovação nesta jornada.</p>
      }
      @if (!podeConcluirAvaliacao && atividadesPendentesAvaliacao.length) {
        <p class="alert">
          Atividades pendentes de avaliação (estrelas):
          <b>{{ titulosAtividadesPendentes }}</b>
        </p>
      }
      @for( atividade of atividadesExibidas; track
      atividade.codigoAtividade; let i = $index) {
      <details
        [ngClass]="{ 'atividade-salva': (atividade.estrelasAvaliacao ?? 0) > 0 }"
        [open]="atividade?.codigoAtividade == atividadeId || atividadePendenteEstrelas(atividade)"
      >
        <summary>{{ atividade.titulo }}</summary>
        <div class="conteudo-detalhes-acordion">
          <div class="row-duas-colunas">
            <div class="col">
              <p><b>Data da Visita:</b></p>
              <p>{{ atividade.dataAtividade | date : "dd/MM/yyyy" }}</p>
              <!-- <p>01/07/2024</p> -->
            </div>
            <div class="col">
              <p><b>Quanto tempo Duração da Atividade:</b></p>
              <div class="flex-horas">
                <p>{{ atividade.tempoAtividade }} mn</p>
              </div>
            </div>
          </div>
          <div class="row-duas-colunas">
            <div class="col">
              <p><b>Tipo de atividade:</b></p>
              <p>{{ getTipoAtividade(atividade.tipoAtividade) }}</p>
            </div>
            <div class="col"></div>
          </div>
          <p>
            <b>Ação Realizada:</b><br />
            {{ atividade.descricaoAcaoRealizada }}
          </p>
          <p>
            <b>Próximos Passos:</b><br />
            {{ atividade.descricaoProximosPassos }}
          </p>

          <div class="conteudo-envolvido">
            @if(hasTipoPessoa(atividade,1)) {

            <h4>Envolvido</h4>
            <div class="card-envolvido">
              @for(envolvido of atividade.envolvidos; track
              envolvido.codigoEnvolvido){

              <div class="header-perfil-chamado perfil-aluno-envolvidos">
                <div>
                  <a
                    href="javascript:void(0)"
                    class="card-chamado aberto"
                    aria-label="Visualizar histórico do envolvido"
                  >
                    <div class="perfil-aluno-chamado ativo">
                      <div class="perfil-aluno encaminhado">
                        <div class="img-aluno">
                          <span>{{ envolvido.iniciais }}</span>
                        </div>
                      </div>
                      <div class="infor-aluno-chamado">
                        <p class="nome-aluno">{{ envolvido.nomeAluno }}</p>
                        <!-- <p class="descricao">Aluno - Ofensor</p> -->
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              }
            </div>

            }@else if( hasTipoPessoa(atividade,2)){
            <h3>Convidados</h3>

            <div class="grid-datatable outros">
              <app-tabulator-table
                [tableData]="atividade.envolvidos"
                [columnNames]="colunasGridEquipeEscolar"
                [tableTitle]="'teste'"
                [tipoRelatorio]="2"
                [orientacaoPortrait]="false"
                [mostrarFiltro]="false"
              />
            </div>
            }@else if(hasTipoPessoa(atividade,4)) {
            <h3>Turmas</h3>
            <div class="grid-datatable">
              <app-tabulator-table
                [tableData]="atividade.envolvidos"
                [columnNames]="colunasGridTurma"
                [tableTitle]="'teste'"
                [tipoRelatorio]="2"
                [orientacaoPortrait]="false"
                [mostrarFiltro]="false"
              />
            </div>
            }@else if(hasTipoPessoa(atividade,3) ) {
            <h3>Convidados</h3>

            <div class="grid-datatable outros">
              <app-tabulator-table
                [tableData]="atividade.envolvidos"
                [columnNames]="colunasGridOutros"
                [tableTitle]="'teste'"
                [tipoRelatorio]="2"
                [orientacaoPortrait]="false"
                [mostrarFiltro]="false"
              />
              <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border"
              aria-describedby="dashboard">
              <thead>
                <tr>
                  <th>Equipe Escola e Outros</th>
                </tr>
              </thead>
              <tbody>
                @for (item of lstEquipeEscolar; track $index) {
                <tr>
                  <td>{{item}}</td>
                </tr>
                }
                @for (item of lstOutros; track $index) {
                <tr>
                  <td>{{item}}</td>
                </tr>
                }
              </tbody>
            </table> -->
            </div>
            }
          </div>

          <div class="grupo-filter-full">
            <h3>Anexos</h3>
            @for( arquivo of atividade.arquivos; track arquivo.codigoAtividade){
            <a [href]="arquivo.caminhoArquivo" class="icon-arquivo">{{
              arquivo.nomeArquivo
            }}</a>
            }
          </div>
          @if (atividadeEnviadaParaAprovacao(atividade) && avaliacoesForms.at(i)) {
          <form
            [formGroup]="avaliacoesForms.at(i)"
            (ngSubmit)="avaliarAtividade(atividade.codigoAtividade)"
            style="width: 100%"
          >
            <div class="conteudo-aprovacao" [class.conteudo-aprovacao--salvando]="atividadeEstaSalvando(atividade.codigoAtividade)">
              <p><b>Avalie a atividade:</b></p>
              @if (atividadeEstaSalvando(atividade.codigoAtividade)) {
                <p class="loading-atividade">
                  <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                  Salvando avaliação...
                </p>
              }
              <new-star-rating-conviva 
                formControlName="estrelas" 
                (ratingChange)="avaliarAtividade(atividade.codigoAtividade)" 
              />
               <div *ngIf="avaliacoesForms.at(i).get('estrelas')?.errors &&
               (avaliacoesForms.at(i).get('estrelas')?.touched )" class="alert">
                  <div *ngIf="avaliacoesForms.at(i).get('estrelas')?.errors?.required">
                    * É obrigatório preencher esse campo
                  </div>

              </div>
            </div>
          </form>
          } @else {
          <div class="conteudo-aprovacao">
            <p class="alert">Atividade ainda não enviada para aprovação.</p>
          </div>
          }
        </div>
      </details>
      }
    
       @if (atividadesEnviadasParaAprovacao.length) {
       <!-- Seção de Justificativa: aparece apenas quando há atividades com 1-3 estrelas -->
       @if (exigeJustificativaAvaliacao) {
         <div class="conteudo-envolvido">
           <details
             [ngClass]="{ 'atividade-salva': justificativaSecaoSalva }"
             [open]="atividadeReprovada || tentouConcluirSemJustificativa"
           >
             <summary>Justificativa da avaliação:</summary>
             <div class="conteudo-detalhes-acordion">
               <form [formGroup]="justificativaAvaliacaoForm" style="width: 100%">
                 <div class="grup_input">
                   <label>
                     Justificativa da avaliação (obrigatória, mínimo 10 caracteres)
                     — necessária para notas entre 1 e 3 estrelas
                   </label>
                   <textarea
                     class="input-textarea"
                     formControlName="justificativaAvaliacao"
                     rows="3"
                     placeholder="Descreva a justificativa da avaliação"
                     aria-label="Descreva a justificativa da avaliação"
                   ></textarea>
                   <p>Quantidade de caracteres atual: {{justificativaAvaliacaoForm.get('justificativaAvaliacao')?.value?.length}}</p>
                   <div *ngIf="justificativaAvaliacaoForm.get('justificativaAvaliacao')?.errors && (justificativaAvaliacaoForm.get('justificativaAvaliacao')?.touched || tentouConcluirSemJustificativa)" class="alert">
                     <div *ngIf="justificativaAvaliacaoForm.get('justificativaAvaliacao')?.errors?.required">
                       * É obrigatório preencher esse campo
                     </div>
                     <div *ngIf="justificativaAvaliacaoForm.get('justificativaAvaliacao')?.errors?.minlength">
                       * É obrigatório no mínimo digitar 10 caracteres.
                     </div>
                     <div *ngIf="justificativaAvaliacaoForm.get('justificativaAvaliacao')?.errors?.maxlength">
                       * Máximo de caracteres é 500.
                     </div>
                   </div>
                 </div>
               </form>
             </div>
           </details>  
         </div>
       }

       <!-- Botão Concluir: ação global, posicionado abaixo de toda a listagem -->
       <div class="conteudo_btn_concluir">
         <button
           type="button"
           class="btn_concluir"
           [attr.disabled]="(!podeConcluirAvaliacao || carregando || concluindo) ? true : null"
           [class.btn_concluir--desabilitado]="!podeConcluirAvaliacao || carregando || concluindo"
           (click)="concluirAvaliacaoAtividade($event)"
           [ngClass]="{ 'atividades_concluidas': podeConcluirAvaliacao && !concluindo && !carregando }"
         >
           @if (concluindo) {
             <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
             Concluindo...
           } @else {
             Concluir
           }
         </button>
       </div>
       }
      </div>
    </div>  
</section>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
